import { TableCell, TableRow } from "../../../design/table";
import { Link } from "../../../design/link";
import { SpousalSupportOrder } from "../../../models/SpousalSupportOrder";

const SpousalSupportOrderListItem: React.FC<{
  spousalSupportOrder: SpousalSupportOrder;
}> = ({ spousalSupportOrder }) => {
  return (
    <TableRow>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        <div className="flex flex-col">
          <Link href={`/child-support-order/${spousalSupportOrder._id}`}>
            {spousalSupportOrder._id}
          </Link>
          <span>{spousalSupportOrder.status}</span>
        </div>
      </TableCell>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        {spousalSupportOrder.amount}
      </TableCell>
      <TableCell className="items-center text-right">
        {spousalSupportOrder.isCurrent ? "Active" : "Inactive"}
      </TableCell>
    </TableRow>
  );
};
export default SpousalSupportOrderListItem;
